import { ReactNode } from 'react';
import { Box, HStack } from '@cbhq/cds-web/layout';
import { TextBody, TextLabel1 } from '@cbhq/cds-web/typography';

import { ClipboardIcon } from '../sharedcomponents';

type DetailItemProps = {
  label: string;
  value?: string;
  showCopy?: boolean;
  actionElement?: ReactNode;
};
export function DetailItem({ actionElement, label, value, showCopy = false }: DetailItemProps) {
  if (!value) {
    return null;
  }
  return (
    <Box
      width="100%"
      spacing={2}
      borderRadius="rounded"
      background="backgroundAlternate"
      alignItems="center"
    >
      <Box width={150}>
        <TextLabel1 as="p">{label}</TextLabel1>
      </Box>
      <HStack justifyContent="space-between" flexGrow={1}>
        <TextBody as="p" color="foregroundMuted">
          {value}
        </TextBody>
        {showCopy && <ClipboardIcon text={value} />}
        {actionElement}
      </HStack>
    </Box>
  );
}
